<template>
  <div class="date-form">
    <slot />

    <form @submit.prevent="submitHandler">
      <div class="columns is-multiline">
        <div class="column is-8 is-flex mobile-justify-around">
          <FormInput
            v-model="day"
            name="day"
            :auto-focus="true"
            :label="$t('dateForm.inputLabels.day')"
            :max-length="2"
            placeholder="12"
            :validator="$v.day"
            @inputFilled="focusNext"
          />
          <FormInput
            v-model="month"
            name="month"
            :label="$t('dateForm.inputLabels.month')"
            :max-length="2"
            placeholder="05"
            :validator="$v.month"
            @inputFilled="focusNext"
          />
          <FormInput
            v-model="year"
            name="year"
            :label="$t('dateForm.inputLabels.year')"
            :max-length="4"
            placeholder="1988"
            :validator="$v.year"
            @inputFilled="focusNext"
          />
          <FormInput
            v-model="time"
            name="time"
            :label="$t('dateForm.inputLabels.time')"
            placeholder="12:34"
            type="flatpickr"
            :validator="$v.time"
          />
        </div>

        <div class="column is-12">
          <button
            :class="['button date-form__submit-button', { 'button date-form__submit-button--loading': isLoading }]"
            :disabled="isSubmitDisabled"
            type="submit"
          >
            <span>{{ submitButtonLabel }}</span>
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import moment from 'moment'
import { required, minLength, between } from 'vuelidate/lib/validators'
import birthDateValidator from '@/scripts/validators/birthDateValidator'
import FormInput from './FormInput.vue'

export default {
  name: 'DateForm',
  components: {
    FormInput,
  },
  props: {
    submitButtonLabel: { type: String, default: 'Submit' },
  },
  validations() {
    return {
      day: {
        required,
        minLength: minLength(1),
        between(value) {
          return between(1, this.maxDaysInMonth)(value)
        },
      },
      month: {
        required,
        minLength: minLength(1),
        between: between(1, 12),
      },
      year: {
        required,
        minLength: minLength(4),
        between: between(1900, moment().year()),
      },
      time: {
        required: false,
      },
      momentDate: {
        birthDateValidator,
      },
      validationGroup: ['day', 'month', 'year'],
    }
  },
  data() {
    return {
      day: '',
      isLoading: false,
      month: '',
      year: '',
      time: '00:00',
    }
  },
  computed: {
    momentDate() {
      return moment(`${this.day}/${this.month}/${this.year} ${this.time}`, 'DD/MM/YYYY HH:mm', true)
    },
    isSubmitDisabled() {
      return this.$v.momentDate.$invalid || this.isLoading
    },
    maxDaysInMonth() {
      if (this.$v.validationGroup.$dirty) {
        return this.momentDate.daysInMonth()
      }

      return 31
    },
  },
  watch: {
    day(value) {
      if (value && value.length < 2) {
        this.day = `0${value}`
      }
    },
    month(value) {
      if (value && value.length < 2) {
        this.month = `0${value}`
      }
    },
    time() {
      if (this.time === '') {
        this.time = '00:00'
      }
    },
  },
  mounted() {
    this.focusableInputs = [...this.$el.querySelectorAll('.input')]
  },
  methods: {
    ...mapActions([
      'changeSectionForward',
      'setBirthDate',
    ]),
    focusNext() {
      const focusedInputIndex = this.focusableInputs.indexOf(document.activeElement)
      const nextInputElement = this.focusableInputs[focusedInputIndex + 1]

      if (nextInputElement) {
        nextInputElement.focus()
      }
    },
    submitHandler() {
      this.$v.$touch()

      if (this.$v.$pending || this.$v.$error) return

      this.setBirthDate(this.momentDate)
      this.setUrl()
      this.isLoading = true

      setTimeout(() => {
        this.changeSectionForward()
        this.isLoading = false
      }, 1000)
    },
    setUrl() {
      ['day', 'month', 'year', 'time'].forEach(param => this.$URLParamsHelper.setParam(param, this[param]))
    },
  },
}
</script>
